import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDefaultFilters as GetDefaultFiltersQuery,
    GetDefaultFiltersVariables as GetDefaultFiltersQueryVariables,
    GetDefaultFilters_defaultFilters as DefaultFilter,
} from 'nutshell-graphql-types';

import GET_DEFAULT_FILTERS from '../queries/get-default-filters.graphql';

export const useGetDefaultFilters = (
    variables: GetDefaultFiltersQueryVariables
): {
    defaultFilters: DefaultFilter[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetDefaultFiltersQuery,
        GetDefaultFiltersQueryVariables
    >(GET_DEFAULT_FILTERS, {
        variables,
        fetchPolicy: 'cache-and-network',
    });

    const defaultFilters = data ? data.defaultFilters : [];

    return {
        defaultFilters: defaultFilters,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
